import * as React from 'react'
import isEmpty from 'lodash/isEmpty'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Popup from '../../../ui/popup'
import Button from '../../../ui/button'
import TextField from '../../../form/TextField'

import { Formik, Form, Field, FieldProps, FormikProps } from 'formik'
import * as Yup from 'yup'

import { ChangeNick } from '../../../../store/member/memberTypings'

import { changeNick } from '../../../../api/member'

interface Props {
    onClose: () => void
}

const ChangeNickPopup: React.FunctionComponent<Props> = ({ onClose }: Props) => {
    const [t] = useTranslation()

    const [message, setMessage] = useState('')

    const initialValues: ChangeNick = {
        nick: ''
    }

    const validationSchema = Yup.object().shape({
        nick: Yup.string().required(t('Nick is required'))
    })

    return isEmpty(message) ? (
        <Popup title={t('Change nick')} onClose={onClose} classname="vertical" profile={true}>
            <Formik
                validateOnChange={false}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values: ChangeNick, formikHelpers): void => {
                    changeNick(values)
                        .then((res: { message: string }) => {
                            setMessage(res.message)
                        })
                        .catch((err) => {
                            formikHelpers.setErrors({ nick: err.messages[0] })
                        })
                }}
            >
                {(props: FormikProps<ChangeNick>) => {
                    const { submitForm } = props
                    return (
                        <Form className="form">
                            <Field name="nick">
                                {({ field, meta }: FieldProps) => (
                                    <TextField
                                        field={field}
                                        type="text"
                                        label={t('New nick')}
                                        error={meta.touched && meta.error}
                                    />
                                )}
                            </Field>
                            <div className="text">
                                {t('nickRules')} <br />
                                {t('disrespect')} <br />
                                {t('referring')} <br />
                                {t('capital')} <br />
                                {t('exists')}
                                <br />
                            </div>
                            <div className="popup__buttons">
                                <Button label={t('Save')} type="button" onClick={submitForm} />
                                <Button label={t('Cancel')} secondary onClick={onClose} />
                            </div>
                        </Form>
                    )
                }}
            </Formik>
        </Popup>
    ) : (
        <Popup onClose={onClose} classname="vertical" title={t('Change nick')} text={message} profile={true} />
    )
}

export default ChangeNickPopup
